import React from 'react';
import { Img } from 'react-image';

interface Props {
	isCompanySelected: boolean;
}

const NoAMBriefDebriefContainer = ({ isCompanySelected }: Props) => {
	return (
		<>
			<div className="flex flex-col items-center justify-center">
				<div className="px-8">
					<div className="flex justify-center">
						<Img
							loading="lazy"
							src="/assets/noApplicationsEmptyState.svg"
							alt="noApplicationsEmptyState"
							width="160"
							height="160"
						/>
					</div>

					<div className="text-center mt-4 text-base font-medium">No brief / debrief calls scheduled</div>
					<div className="text-center mt-2 text-sm font-normal text-[#28293D] dark:text-[#C7C9D9]">
						{!isCompanySelected ? 'Select a company to view the calls' : 'Schedule a call to get started'}
					</div>
				</div>
			</div>
		</>
	);
};

export default NoAMBriefDebriefContainer;
